// Date-header renderer for the selectable gallery: a select-circle to toggle the whole day,
// plus a draggable date text that drops the day's photos like a multi-selection.
// Filters inject plain "label" objects, so it is registered under the "Object" key.
// The day toggle and the day's photos come from the grid (this._shared.owner).
fx.ns("shared.renderers", class PhotoDateLabelRenderer extends fx.components.DefaultRenderer {

	constructor(data, sharedData)
	{
		super(data);

		this._shared = sharedData;

		// fx keeps only the leaf class name -> re-add DefaultRenderer for its styling
		this.className = "DefaultRenderer";
	}

	get _owner()
	{
		return this._shared && this._shared.owner;
	}

	// ids of the day's first photos (capped like the selection), for the drag payload
	_dayPhotoIds()
	{
		let owner = this._owner;
		if (!owner || !owner._groupPhotosForLabel) return [];

		let cap = owner.maxSelection;
		let photos = owner._groupPhotosForLabel(this.data);
		let ids = [];

		for (let i = 0; i < photos.length && ids.length < cap; i++)
			if (photos[i] && photos[i].id != null)
				ids.push(photos[i].id);

		return ids;
	}

	render()
	{
		let owner = this._owner;
		let selected = (owner && owner.isDateGroupSelected && owner.isDateGroupSelected(this.data)) ? " selected" : "";
		let text = (this.data && this.data.text) ? this._escape(this.data.text) : "";

		// dragging the date drops its photos (data-contents) ; data-group stops a plain click
		let ids = this._dayPhotoIds();
		let attrs = "class='date-text'";
		if (ids.length)
			attrs = "class='date-text draggable' data-class='Photo' data-behaviour='add-component'"
				+ " data-group='1' data-id='" + ids[0] + "' data-contents='" + ids.join(",") + "'";

		return "<span class='select-circle date-select" + selected + "'></span><span " + attrs + ">" + text + "</span>";
	}

	// labels can be user-controlled (guest names) -> escape before innerHTML
	_escape(s)
	{
		return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
	}

	onReady()
	{
		super.onReady();

		let circle = this.node ? this.node.querySelector(".date-select") : null;
		if (circle && !circle._bound)
		{
			circle._bound = true;
			circle.addEventListener("click", this._onCircleClick.bind(this));
		}
	}

	// clicking the circle toggles the whole day
	_onCircleClick(e)
	{
		if (e && typeof e.stopPropagation == "function")
			e.stopPropagation();

		let owner = this._owner;
		if (owner && owner.toggleDateGroup)
			owner.toggleDateGroup(this.data);
	}

	// called by the grid to reflect the day's selected state
	setChecked(selected)
	{
		if (!this.node) return;

		let circle = this.node.querySelector(".date-select");
		if (!circle) return;

		if (selected)
			fx.dom.addClass(circle, "selected");
		else
			fx.dom.removeClass(circle, "selected");
	}
});
